import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.minimap');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RemotePlayer } from "src/libs/portal/metaverse/types";

@Component({
    selector: 'wiz-component-minimap',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.minimap/view.scss */
:host {
  display: block;
}`],
})
export class ComponentMinimapComponent implements OnInit, OnDestroy {
    @ViewChild('minimapCanvas', { static: false }) minimapCanvasRef!: ElementRef<HTMLCanvasElement>;

    @Input() mapWidth: number = 2200;
    @Input() mapHeight: number = 1160;
    @Input() playerX: number = 0;
    @Input() playerY: number = 0;
    @Input() cameraX: number = 0;
    @Input() cameraY: number = 0;
    @Input() canvasWidth: number = 0;
    @Input() canvasHeight: number = 0;
    @Input() remotePlayers: { [sid: string]: RemotePlayer } = {};
    @Input() room: string = 'solution';
    @Input() sharedState: { playerX: number, playerY: number, cameraX: number, cameraY: number } | null = null;

    private minimapImage: HTMLImageElement | null = null;
    private minimapLoaded: boolean = false;
    public minimapLarge: boolean = false;

    private MINIMAP_WIDTH = 240;
    private MINIMAP_HEIGHT = 120;
    private MINIMAP_LARGE_WIDTH = 360;
    private MINIMAP_LARGE_HEIGHT = 180;

    private animFrameId: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.loadMinimapImage();
        this.startRenderLoop();
    }

    public ngOnDestroy() {
        if (this.animFrameId) cancelAnimationFrame(this.animFrameId);
    }

    private loadMinimapImage() {
        this.minimapImage = new Image();
        this.minimapLoaded = false;
        const mapName = this.room === 'research' ? 'research_center_map' : 'solution_center_map';
        const mapSrc = `/assets/images/${mapName}.png`;
        this.minimapImage.onload = () => { this.minimapLoaded = true; };
        let retryCount = 0;
        this.minimapImage.onerror = () => {
            if (retryCount < 3) {
                retryCount++;
                setTimeout(() => {
                    if (this.minimapImage) {
                        this.minimapImage.src = '';
                        this.minimapImage.src = `${mapSrc}?t=${Date.now()}`;
                    }
                }, 500 * retryCount);
            }
        };
        this.minimapImage.src = mapSrc;
    }

    private startRenderLoop() {
        const loop = () => {
            this.renderMinimap();
            this.animFrameId = requestAnimationFrame(loop);
        };
        this.animFrameId = requestAnimationFrame(loop);
    }

    public async toggleSize() {
        this.minimapLarge = !this.minimapLarge;
        await this.service.render();
        if (this.minimapCanvasRef?.nativeElement) {
            const w = this.minimapLarge ? this.MINIMAP_LARGE_WIDTH : this.MINIMAP_WIDTH;
            const h = this.minimapLarge ? this.MINIMAP_LARGE_HEIGHT : this.MINIMAP_HEIGHT;
            this.minimapCanvasRef.nativeElement.width = w;
            this.minimapCanvasRef.nativeElement.height = h;
        }
    }

    private renderMinimap() {
        if (!this.minimapCanvasRef) return;
        const canvas = this.minimapCanvasRef.nativeElement;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const mmW = this.minimapLarge ? this.MINIMAP_LARGE_WIDTH : this.MINIMAP_WIDTH;
        const mmH = this.minimapLarge ? this.MINIMAP_LARGE_HEIGHT : this.MINIMAP_HEIGHT;

        ctx.clearRect(0, 0, mmW, mmH);

        if (this.minimapLoaded && this.minimapImage) {
            ctx.globalAlpha = 0.92;
            ctx.drawImage(this.minimapImage, 0, 0, mmW, mmH);
            ctx.globalAlpha = 1.0;
        } else {
            ctx.fillStyle = 'rgba(50, 50, 50, 0.5)';
            ctx.fillRect(0, 0, mmW, mmH);
        }

        const scaleX = mmW / this.mapWidth;
        const scaleY = mmH / this.mapHeight;

        // 공유 상태에서 최신 좌표 읽기 (매 프레임 갱신됨)
        const px = this.sharedState ? this.sharedState.playerX : this.playerX;
        const py = this.sharedState ? this.sharedState.playerY : this.playerY;
        const cx = this.sharedState ? this.sharedState.cameraX : this.cameraX;
        const cy = this.sharedState ? this.sharedState.cameraY : this.cameraY;

        // 카메라 뷰포트 표시
        const vpX = cx * scaleX;
        const vpY = cy * scaleY;
        const vpW = this.canvasWidth * scaleX;
        const vpH = this.canvasHeight * scaleY;
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
        ctx.lineWidth = 1;
        ctx.strokeRect(vpX, vpY, vpW, vpH);

        // 원격 플레이어 (주황색 점)
        const remoteDotR = this.minimapLarge ? 5 : 4;
        for (const sid of Object.keys(this.remotePlayers)) {
            const p = this.remotePlayers[sid];
            const mx = p.x * scaleX;
            const my = p.y * scaleY;
            ctx.beginPath();
            ctx.arc(mx, my, remoteDotR, 0, Math.PI * 2);
            ctx.fillStyle = '#F97316';
            ctx.fill();
        }

        // 내 플레이어 (초록색 점)
        const selfDotR = this.minimapLarge ? 6 : 5;
        const myMx = px * scaleX;
        const myMy = py * scaleY;
        ctx.beginPath();
        ctx.arc(myMx, myMy, selfDotR, 0, Math.PI * 2);
        ctx.fillStyle = '#10B981';
        ctx.fill();
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
    }
}

export default ComponentMinimapComponent;